import { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import OutcomeBlock from "./OutcomeBlock";


const newConditionRow = () => ({
  id: Date.now() + Math.random(),
  attributeType: "",
  attributeFilterType: "",
  attributeFilterClause: "",
  attributeFilterValue: "",
  nextOperator: null
});

const newOutcomeBlock = () => ({
  id: Date.now() + Math.random(),
  when: [newConditionRow()],
  then: {
    discount: {
      discountType: "DISCOUNT_ON_MRP",
      discountPercentage: "",
    }
  }
});

export default function OutcomeGenerator({ form, setField, enums,
  selectedCategory, selectedProduct, selectedSku,
  attributeConfig, categories, products, skus, locations }) {
  const [blocks, setBlocks] = useState(form?.then?.subConditions ?? [newOutcomeBlock()]);
  const DISCOUNT_TYPES = Object.keys(enums.DiscountType);

  useEffect(() => {
    setField('then', {
      ...form.then,
      subConditions: blocks
    });
  }, [blocks]);

  const addOutcomeBlock = () => setBlocks((prev) => [...prev, newOutcomeBlock()]);

  const removeOutcomeBlock = (blockId) => {
    setBlocks((prev) => prev.filter((b, index) => index !== blockId));
  };

  const addCondition = (blockId) => {
    setBlocks((prev) =>
      prev.map((b, index) => {
        if (index !== blockId) return b;
        const when = [...b.when];
        // ensure the previous condition has a joiner (default to AND)
        if (when.length > 0) {
          const last = when[when.length - 1];
          when[when.length - 1] = {
            ...last,
            nextOperator: last.nextOperator ?? "AND",
          };
        }
        return { ...b, when: [...when, newConditionRow()] };
      })
    );
  };

  const removeCondition = (blockId, conditionId) => {
    setBlocks((prev) =>
      prev.map((b, index) =>
        index === blockId
          ? { ...b, when: b.when.map((c, ind) => ind === conditionId - 1 ? { ...c, nextOperator: null } : c).filter((c, ind) => ind !== conditionId) }
          : b
      )
    );
  };

  const updateCondition = (blockId, block) => {
    setBlocks((prev) =>
      prev.map((b, index) =>
        index === blockId
          ? block
          : b
      )
    );
  };

  const updateLogic = (blockId, conditionIndex, value) => {
    setBlocks((prev) =>
      prev.map((b, index) =>
        index === blockId
          ? {
            ...b,
            when: b.when.map((c, idx) =>
              idx === conditionIndex ? { ...c, nextOperator: value } : c
            ),
          }
          : b
      )
    );
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: 800, mb: 2 }}>
        Step 3 — Outcome Generator
      </Typography>

      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          {/* Top Right: Add Outcome */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={addOutcomeBlock}
              sx={{ borderRadius: 2, textTransform: "none" }}
            >
              Add Outcome
            </Button>
          </Box>

          {/* Blocks */}
          {blocks.map((block, blockIndex) => (
            <OutcomeBlock
              key={block.id}
              block={block}
              blockIndex={blockIndex}
              onUpdateLogic={updateLogic}
              onUpdate={updateCondition}
              onRemoveCondition={removeCondition}
              onRemoveOutcomeBlock={removeOutcomeBlock}
              enums={enums}
              categories={categories}
              products={products}
              skus={skus}
              locations={locations}
              attributeConfig={attributeConfig}
              selectedCategory={selectedCategory}
              selectedProduct={selectedProduct}
              selectedSku={selectedSku}
              blocksLength={blocks.length}
              onAddCondition={addCondition}
              form={form}
            />
          ))}
        </CardContent>
      </Card>
    </Box>
  );
}
